export const CaptureVariableIcon = ({
  className,
  strokeWidth,
  width,
  height,
  color,
}: {
  className?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
  color?: string;
}) => (
  <div
    className={`text-primary-accent ${className ? className + " " : ""}relative flex items-center justify-center`}
    style={color ? {color} : undefined}
  >
    <VariableSVG strokeWidth={strokeWidth} width={width} height={height} />
  </div>
);

export const VariableSVG = ({
  strokeWidth = 2,
  width = 24,
  height = 24,
}: {
  strokeWidth?: number;
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill="none"
  >
    <path
      d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g transform="translate(6 6) scale(0.5)">
      <path
        d="M12 5v14"
        stroke="currentColor"
        strokeWidth={strokeWidth + 1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m19 12-7 7-7-7"
        stroke="currentColor"
        strokeWidth={strokeWidth + 1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
